import 'app_globals'
import React from 'react'
import NavigationRouter from 'navigation/NavigationRouter'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

import {Provider} from 'react-redux'
import store from 'store/Store'
import {RTL} from 'mui/RTL.js'
import {theme} from 'mui/Theme.js'
import {ThemeProvider} from '@mui/material'

const App = () => {
    return (
        <Provider store={store}>
            <RTL>
                <ThemeProvider theme={theme}>
                    <NavigationRouter />
                </ThemeProvider>
            </RTL>
        </Provider>
    )
}

export default App
